<template>
  <div class="preview-image" v-if="mediaCount > 0" @click.prevent.stop="onImageClick()">
    <ArtworkImage :image="images[0]" version="200" v-if="images[0]" />
    <div class="thumb-icon" v-if="media.length && images[0]">
      <span :class="thumbIconClass" class="fa fa-3x media-icon"></span>
    </div>
    <div class="no-image-content" v-else-if="media.length && !images[0]">
      <div class="thumb-icon">
        <span :class="thumbIconClass" class="fa fa-3x media-icon"></span>
      </div>
    </div>
    <ArtworkMediaLegend :artwork="artwork" :header="header" />
  </div>
</template>
<script>
import ArtworkImage from './ArtworkImage.vue';
import ArtworkMediaLegend from './ArtworkMediaLegend.vue';

export default {
  name: 'ArtworkSidebarPreviewImage',
  components: {
    ArtworkImage,
    ArtworkMediaLegend,
  },
  props: {
    artwork: Object,
    header: Boolean,
  },
  methods: {
    onImageClick() {
      this.$emit('setElement');
      if (this.$isMobile() && this.artwork.type !== 'individual') {
        this.$root.$emit('bv::show::modal', 'mobileArtworkMainImage');
      }
    },
  },
  computed: {
    medias() {
      return this.artwork.medias || [];
    },
    media() {
      return this.medias.filter((m) => m.type !== 'image' && m.header_aggregate === this.header);
    },
    mediaImages() {
      return this.medias.filter((m) => m.type === 'image' && m.header_aggregate === false);
    },
    mediaHeaders() {
      return this.medias.filter((m) => m.type === 'image' && m.header_aggregate === true);
    },
    images() {
      return this.header ? this.mediaHeaders : this.mediaImages;
    },
    mediaCount() {
      return this.medias.length;
    },
    thumbIconClass() {
      return {
        'fa-music': this.media[0].type == 'audio',
        'fa-video-camera': this.media[0].type == 'video',
      };
    },
  },
};
</script>

<style lang="less" scoped>
.no-image-content {
  .thumb-icon {
    width: 170px;
    height: 130px;
  }
}
</style>
